import React from 'react';

import { SimpleFormStepProps, FormStepMode } from '@epi-models/pages/Transfer';

import { FormStep } from '../FormStep/FormStep';
import { FormStepLabel } from '../FormStepLabel/FormStepLabel';
import { FormStepStyles } from '../FormStep/FormStep.styles';

export const SimpleFormStep = ({
  mode = FormStepMode.Contained,
  stepNumber,
  stepTitle,
  children,
  pr
}: SimpleFormStepProps) => {
  return (
    <FormStep mode={mode} stepNumber={stepNumber}>
      <FormStepStyles.Content pr={pr}>
        <FormStepLabel
          mode={mode}
          stepNumber={stepNumber}
          stepTitle={stepTitle}
        />
        {children}
      </FormStepStyles.Content>
    </FormStep>
  );
};
